import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Site-wide slim footer. Renders three legal/utility links + copyright.
 *
 * Placement guide:
 *  - Public pages (landing, tip page, auth pages): append at the end of the
 *    root <div>. Flows naturally.
 *  - Authed pages with a fixed mobile bottom nav: place at the end of <main>
 *    so the surrounding `pb-24 md:pb-8` padding lifts the footer above the
 *    fixed nav on mobile viewports.
 */
export default function Footer({ className = '' }) {
  const year = new Date().getFullYear();
  return (
    <footer
      className={`border-t border-white/5 py-6 px-4 md:px-8 text-center text-xs text-[#52525B] ${className}`}
      data-testid="site-footer"
    >
      <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mb-2">
        <Link to="/terms" className="hover:text-white transition-colors" data-testid="footer-terms-link">
          Terms
        </Link>
        <span aria-hidden>·</span>
        <Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-privacy-link">
          Privacy
        </Link>
        <span aria-hidden>·</span>
        <Link to="/contact" className="hover:text-white transition-colors" data-testid="footer-contact-link">
          Contact
        </Link>
        <span aria-hidden>·</span>
        <Link to="/about" className="hover:text-white transition-colors" data-testid="footer-about-link">
          About
        </Link>
      </nav>
      <p>© {year} Golden Tips. All rights reserved.</p>
    </footer>
  );
}
